module.exports = "<div class=\"{{baMultiCheckboxClass}} container-content\">\n  <ba-checkbox *ngFor=\"let item of state\"\n               [(ngModel)]=\"item[propertiesMapping.model]\"\n               [baCheckboxClass]=\"getProp(item, 'baCheckboxClass')\"\n               [label]=\"getProp(item, 'label')\"\n               [disabled]=\"getProp(item, 'disabled')\"\n               [value]=\"getProp(item, 'value')\"\n               id=\"{{getProp(item, 'id')}}\">\n  </ba-checkbox>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/baMultiCheckbox/baMultiCheckbox.html
// module id = ../../../../../src/app/theme/components/baMultiCheckbox/baMultiCheckbox.html
// module chunks = 14